module.exports = __webpack_public_path__ + "img/games.2b298126.webp";